import React, { useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import CrudProducts from "../../organisms/Products/ProductCrud";
import { useCompany } from "../../contexts/CompanyContext";
import { Box, Grid, Stack, Tab, Tabs, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LGTabPanel } from "../../molecules/LGTabPanel";
import CrudCatalogue from "../../organisms/Catalogues/CrudCatalogue";
import CrudProductCategories from "../../organisms/Catalogues/CrudProductCategories.tsx";

export default function ProductScreen() {
  const { selectedCompany } = useCompany();
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  if (!selectedCompany) {
    return (
      <DashboardLayout>
        <Box p={4}>
          <Typography>Seleccione una compañía primero</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Box
        sx={{
          backgroundColor: "white", 
          borderBottom: 1,
          borderColor: "divider",
          position: "fixed",
          zIndex: 99,
          width: "100%",
        }}
      >
        <Tabs value={activeTab} onChange={handleChange}>
          <Tab label={`Productos ${selectedCompany.name}`} />
          <Tab label="Catálogos" />
        </Tabs>
      </Box>

      <LGTabPanel value={activeTab} index={0}>
        <CrudProducts companyId={selectedCompany.id} />
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={1}>
        <Box sx={{ maxWidth: '800px', margin: '0 auto', mt: 5 }}>
          <Stack spacing={2}>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Tipos de Productos</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="PRODUCT_TYPE" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Acabados</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="PRODUCT_FINISH" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Colores</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="PRODUCT_COLOR" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Categorías de Productos</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudProductCategories />
              </AccordionDetails>
            </Accordion>
          </Stack>
        </Box>
      </LGTabPanel>

    </DashboardLayout>
  );
}
